import { ArticleType } from '@yi/core/src/gql/generated/typesSsr';

import { isArticleWithMedia } from './isArticleWithMedia';

type Content = {
  entry_type: ArticleType;
  media_duration: {
    minutes: number;
  } | null;
};

const DEFAULT_ARTICLE_READ_TIME_IN_MIN = 5;

export function getDurationInMinutes(content: Content): number | null {
  const isMediaArticle = isArticleWithMedia(content);

  if (isMediaArticle) {
    const mediaDuration = content?.media_duration?.minutes ?? null;
    return mediaDuration;
  } else {
    return DEFAULT_ARTICLE_READ_TIME_IN_MIN;
  }
}
